import { render, staticRenderFns } from "./Base_Device_80_81.vue?vue&type=template&id=206286ef&"
import script from "./Base_Device_80_81.vue?vue&type=script&lang=js&"
export * from "./Base_Device_80_81.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports